import Brand from '../views/brands/Index.vue';
import { checkauth } from '../Helper';

// inserimento e modifica sono pagine: tornando indietro la lista riparte dal suo URL
const BrandCreate = () => import('../views/brands/Create.vue');
const BrandEdit = () => import('../views/brands/Edit.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/brands',
		name: 'brands',
		component: Brand,
		beforeEnter: auth,
	},
	{
		path: '/brands/new',
		name: 'brand-new',
		component: BrandCreate,
		beforeEnter: auth,
	},
	// :id e' l'_id della marca (24 caratteri esadecimali): "new" non puo' mai finire qui
	{
		path: '/brands/:id([0-9a-fA-F]{24})',
		name: 'brand-edit',
		component: BrandEdit,
		beforeEnter: auth,
	},
];
